<template>
  <v-toolbar fixed>
    <v-toolbar-side-icon @click="toggleSidebar" />
    <slot name="title" :title="title">
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </slot>
    <v-spacer />
    <!-- Default slot for more items to go inside the toolbar -->
    <slot />
  </v-toolbar>
</template>

<script>
/**
 * A base toolbar that only renders a title and a button to toggle the sidebar.
 * You can customize the title by implementing the `#title={ title }` slot or change
 * the title by simply changing the `title` prop.
 */
export default {
  props: {
    /* The title of the toolbar */
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    /**
     * Emit the event 'toggle-sidebar' when the toolbar-side-icon is clicked.
     */
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    }
  }
};
</script>
